import Guide from "../Guid";
import Camera from "../Camera";
import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import React, {useContext, useRef, useState} from "react";
import CompareFaceGuide_image from "../../images/guide/compareFaces_guide.png";
import Api from "../../tools/service";
import {Reoverlay} from "reoverlay";
import CompareFaceConfirmModal from "../modals/CompareFaceConfirmModal";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";
import ErrorModal from "../modals/ErrorModal";
import Swal from "sweetalert2";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import ProgressLoading from "../loading/ProgressLoading";
import REQUEST_URLS from "../../tools/defaults/requestUrl";

const CompareFaceGuidSlides = [{
    image: CompareFaceGuide_image,
    title: "ونیفای",
    subTitle: "عکس از چهره",
    texts: `در شرایط نوری مناسب  بدون عینک و ماسک از چهره خود عکس بگیرید .  `,
    warning: null,
},]
const CompareFaces = () => {
    const serviceContext = useContext(AuthenticationServiceContext)
    const CompareFaceWebcam = useRef(null);
    const [showGuide, setShowGuide] = useState(true);
    const [isLoading, setLoading] = useState(false)
    const [step, setStep] = useState(1);
    const [image, setImage] = useState('');

    const handlePrev = () => {
        setStep(step - 1);
    }
    const onFaceCapture = (base64Image) => {
        setImage(base64Image);
        setStep(step + 1)
    }
    const handleConfirmWidget = (values) => {
        setLoading(true)
        Reoverlay.hideModal();

        Api.put(REQUEST_URLS.AUTHENTICATION.CONFIRM_IMG_WIDGET, {
            pid: serviceContext.pid,
            ...values,
        }, {
            headers: {
                "Authorization": `Bearer ${serviceContext.token}`
            }
        }).then((response) => {
            const {data, hasError, message, status} = response;
            setLoading(false)
            if (!hasError) {
                serviceContext.handleGetProcess(serviceContext.pid)
                Reoverlay.hideModal()
            } else {
                serviceContext.handleError({
                    message, status, data, callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            pid: serviceContext.pid,
                            onConfirm: () => {
                                Reoverlay.hideModal()
                                if (data?.can_reset) {
                                    serviceContext.handleReset(serviceContext.pid)

                                }
                            },
                            showConfirmButton: data?.can_reset,
                            confirmButtonText: 'ویرایش اطلاعات',
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onCancel: () => {

                                Reoverlay.hideModal()

                            }
                        })
                    }
                })
            }
        }).catch((e) => {
            setLoading(false)
            console.log(e)
            Swal.fire({
                allowOutsideClick: false,
                text: 'مشکلی پیش آمده‌است',
                title: "ناموفق",
                icon: 'error',
                cancelButtonText: 'تلاش مجدد',
                showCancelButton: true,
                showConfirmButton: false,
            })
        })
    }
    const handleCompareFace = () => {
        setLoading(true)

        handleGenerateUuid('CompareFaces', serviceContext.token).then((uuid) => {
            Api.post(REQUEST_URLS.AUTHENTICATION.COMPARE_FACES, {
                pid: serviceContext.pid, uuid: uuid, Image2: image.replace('data:image/jpeg;base64,', ''),
            }, {
                headers: {
                    "Authorization": `Bearer ${serviceContext.token}`
                },
            }).then((response) => {
                const {data, hasError, status, message} = response;

                if (!hasError) {
                    Reoverlay.showModal(CompareFaceConfirmModal, {
                        "name": 'تایید تصویر ',
                        "description": " چهره شما به صورت زیر بر روی آگهی قرار می گیرد.",
                        "userImage": data?.widget_data?.face_img || "",
                        "userName": data?.widget_data?.full_name || "",
                        "token": serviceContext.token,
                        onConfirm: (values) => {
                            handleConfirmWidget(values);
                        },
                        onCancel: () => {
                            handlePrev()
                        }

                    })

                } else {
                    serviceContext.handleError({
                        message, status, data, callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای سرویس',
                                pid: serviceContext.pid,
                                onConfirm: () => {
                                    Reoverlay.hideModal();
                                    if (data?.can_reset) {
                                        serviceContext.handleReset(serviceContext.pid)
                                    }
                                },
                                showConfirmButton: data?.can_reset,
                                confirmButtonText: 'ویرایش اطلاعات',
                                showCancelButton: true,
                                cancelButtonText: 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                onCancel: () => {

                                    Reoverlay.hideModal();
                                    setShowGuide(false)
                                    setStep(1);

                                }
                            })
                        }
                    })

                }

            }).catch(() => {
            }).finally(() => {
                setLoading(false)
            })
        }).catch(() => {

        })
    }
    if (isLoading) {
        return <ProgressLoading type="CompareFaces" duration={30} showProgress={false} theme="green"
                                text={'در حال احراز هویت تصویری'}/>
    }

    return <div className="w-11/12 mx-auto md:w-6/12 mt-5   lg:w-5/12 xl:w-3/12">
        {showGuide && step === 1 &&
            <Guide imageClass={'w-8/12  md:w-8/12 lg:w-3/12 xl:w-2/12 '} closeGuid={() => setShowGuide(false)}
                   slides={CompareFaceGuidSlides}/>}
        {!showGuide && step === 1 &&
            <Camera galleryEnable={false} text="در شرایط نوری مناسب از چهره خود عکس بگیرید." title={'عکس چهره کاربر'}
                    cropperEnable={false}
                    handleShowGuid={() => {
                        setShowGuide(true)
                    }} faceMode="user" webcamRef={CompareFaceWebcam} onCapture={onFaceCapture} isVideo={false}
                    type="face"/>}
        {!showGuide && step === 2 && <>
            <div className="grid gap-1 grid-cols-1">
                <img className="w-full h-auto rounded-lg" src={image} alt=""/>
            </div>
            <BottomButtonWrapper grid={2}>
                <Button onClick={handleCompareFace} className={"w-full"} rounded="rounded-lg"
                        theme="green">تایید</Button>
                <Button onClick={() => {
                    handlePrev()
                }} className={"w-full"} rounded="rounded-lg" theme="light">تلاش مجدد</Button>
            </BottomButtonWrapper>
        </>}

    </div>
}
export default CompareFaces;